import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { PrescriptionPrescriptionTypeEnum } from '@redteclab/api/clients/bully'

import { Dialog, DialogContent, DialogTitle } from 'base-ui'

import { priceAccessorGetDisplayPrice } from '../../model/priceAccessor/priceAccessorGetDisplayPrice'
import { productAccessorIsLifestyleProduct } from '../../model/productAccessor/productAccessorIsLifestyleProduct'
import { useProductPageContext } from '../productPageContext'

import { ProductPricingProductSection } from './ProductPricingProductSection'

type ProductPricingDialogProps = {
  isOpen: boolean
  onClose: () => void
}

export const ProductPricingDialog: FC<ProductPricingDialogProps> = ({
  isOpen,
  onClose,
}) => {
  const { currentOffer, currentPrescriptionType, product } =
    useProductPageContext()
  if (!currentOffer) {
    return null
  }
  const productPrescriptionPrice = priceAccessorGetDisplayPrice(
    currentOffer,
    currentPrescriptionType,
  )
  const haveFixedPriceDifference =
    productPrescriptionPrice?.fixedPriceDifference &&
    productPrescriptionPrice.fixedPriceDifference > 0

  const isLifestyleProduct: boolean = productAccessorIsLifestyleProduct(product)
  const showProductSection = (): boolean => {
    if (isLifestyleProduct) {
      return true
    }

    switch (currentPrescriptionType) {
      case PrescriptionPrescriptionTypeEnum.FreePrescription:
      case PrescriptionPrescriptionTypeEnum.InsurancePrescription: {
        if (haveFixedPriceDifference) {
          return true
        }

        return false
      }
      default: {
        return false
      }
    }
  }

  return (
    <Dialog data-qa-id="product-pricing-dialog" onClose={onClose} open={isOpen}>
      <DialogTitle onClose={onClose}>
        <FormattedMessage id="productPricing.modal.title" />
      </DialogTitle>
      <DialogContent className="px-4 py-6">
        {showProductSection() ? <ProductPricingProductSection /> : null}

        {/* Temporariliry disbled as we don't show the bonus
        <ProductPricingBonusSection />
        */}
      </DialogContent>
    </Dialog>
  )
}
